import React from "react";
import { Fragment } from "react";


export default function SignOut() {
      const [isModalVisible, setIsModalVisible] = React.useState(false);

    const handleSignOut = () => {
        // Clear the token from local storage
        localStorage.removeItem('token');

        // Redirect to the login page
        window.location.href = "/login";
    };

    const handleCancel = () => {
        // Hide the modal
        setIsModalVisible(false);
    }
    const handleSignOutClick = () => {
        // Show the modal
        setIsModalVisible(true);
    };

    if (isModalVisible) {
        return (
            
            <Fragment>
                <span className="signout-text">
                    <p  onClick={handleSignOutClick}>Sign Out</p>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                    </svg>
                </span>

        
                {/* Light grey background covering the entire screen with a 50% opacity. absolute positioned to take up whole screen with higher z index. */}
                <div className="modal-background">
        
                    {/* conditionally rendered modal popup with a warning icon and a message, appears in the exact middle of the parent div */}
                    <article style={{
                        textAlign: 'center',
                        marginTop: '4rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #C1D3E3',
                        borderRadius: '10px',
                        padding: '20px',
                        width: '100%',
                        maxWidth: '500px',
                        height: '500px',
                        
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="warning-icon">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                        </svg>
                        <h2 style={{fontWeight: '300'}}>Sign Out</h2>
                        <p style={{maxWidth: '420px'}}>Are you sure you would like to sign out? You will be redirected to the login page afterwards.</p>
                        <div style={{display: 'flex', gap: '2rem', paddingTop: '2rem'}}>
                            <button className="primary-button" onClick={handleSignOut} style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                color: 'white',
                                fontWeight: 'bold',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}>
                                Sign Out
                            </button>
                            <button className="secondary-button" onClick={handleCancel} style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}>
                                Cancel
                            </button>
                        </div>
                    </article>
        
                </div>

            </Fragment>

        );
    } else {
        // Just show the sign out button at top right
        return (
            <span className="signout-text">
                <p  onClick={handleSignOutClick}>Sign Out</p>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                </svg>
            </span>
        )
    }
}